

























































import { Component } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { InstitutionsModule } from '@/store/Settings/InstitutionsModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import InstitutionDetails from '@/components/Settings/Institutions/Details/InstitutionDetails.vue';
import InstitutionIntegrations from '@/components/Settings/Institutions/Integrations/InstitutionIntegrations.vue';
import InstitutionAccounts from '@/components/Settings/Institutions/Accounts/InstitutionAccounts.vue';
import InstitutionFeatures from '@/components/Settings/Institutions/Features/InstitutionFeatures.vue';
import InstitutionTheme from '@/components/Settings/Institutions/Theme/InstitutionTheme.vue';

@Component({ name: 'Institution',  components: { Alert, InstitutionDetails, InstitutionIntegrations, InstitutionAccounts, InstitutionFeatures, InstitutionTheme }, metaInfo: { title: 'Institutions' } })
export default class extends SaascadaVue {

    tabIndex = 0;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    async beforeMount() {
        await InstitutionsModule.getInstitution(this.$route.params.id);
    }

    get institution() {
        return InstitutionsModule.institution;
    }

    get loading() {
        return InstitutionsModule.loading;
    }

    get isSaaScadaUser() {
        return AuthModule.me.email.includes('@saascada.com');
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
